import React from "react";

const SearchBar = () => {
  return <div>search bar</div>;
};

export default SearchBar;
